import Client from '@/client'

export default {
  predict(id, payload) {
    return Client.post(`virtualwell/${id}/predict/`, payload)
  },
}